import { render, staticRenderFns } from "./UniformRequestList.vue?vue&type=template&id=6d2da106&scoped=true"
import script from "./UniformRequestList.vue?vue&type=script&lang=js"
export * from "./UniformRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2da106",
  null
  
)

export default component.exports